export const DEVICE = {
  POS: 0,
  TOTEN: 1,
}